export const api = {
  postWaterUnitCount: "/api/supervision/waterScreen/getUseWaterUnitCount", // 用水单位相关统计
  postWaterInfo: "/api/supervision/waterScreen/getWaterUnitCount", // 统计水站信息
  postWarn: "/api/supervision/waterScreen/getViolationWarn", // 预警
  postMapWarn: "/api/supervision/waterScreen/findWaterUnitPlace" // 地图
};
